export default "__VITE_ASSET__DQBnebRy__"